(ns frontend.ui.component.steps-band.style
  (:require
   [garden.util :refer [space-join]]
   [garden.units :refer [px]]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer
    [color edge-size border-radius text-size border-width font-weight]]))

(defn step-content
  [status]
  {:display "block"
   :color   (color [:steps-band :step :fg status])})

(def ^:private step-style-pseudo-before-after
  {:content       "''"
   :display       "block"
   :width         "0"
   :height        "0"
   :border-top    (space-join ["50px" "solid" (theme/color [:palette :transparent])])
   :border-bottom (space-join ["50px" "solid" (theme/color [:palette :transparent])])
   :position      "absolute"
   :top           "50%"
   :margin-top    "-50px"
   :left          "95%"})

(defn step
  [status]
  (with-meta
    {:display          "flex"
     :align-items      "center"
     :justify-content  "center"
     :cursor           (if (= status :completed) "pointer" "default")
     :padding          (space-join [(edge-size :xxsmall)
                                    (edge-size :small)])
     :color            [:steps-band :step :fg status]
     :border-radius    (space-join [(border-radius :xxxsmall)
                                    0
                                    0
                                    (border-radius :xxxsmall)])
     :position         "relative"
     :background-color (color [:steps-band :step :bg status])}
    {:pseudo
     {:before (-> step-style-pseudo-before-after
                  (assoc :border-left
                         (space-join ["30px" "solid"
                                      (theme/color [:steps-band :step :border-left :before])])
                         :margin-left "1px"
                         :z-index "1"))
      :after  (-> step-style-pseudo-before-after
                  (assoc :border-left
                         (space-join
                          ["30px solid"
                           (theme/color [:steps-band :step :border-left :after status])])
                         :z-index "2"))}}))

(defn step-icon
  [status]
  {:display          "flex"
   :justify-content  "center"
   :align-items      "center"
   :min-width        "26px"
   :height           "26px"
   :min-height       "26px"
   :margin           (space-join [0 (edge-size :xxsmall)])
   :border-radius    (border-radius :round)
   :font-size        (text-size :small :size)
   :background-color (theme/color [:steps-band :step-icon status :bg])
   :color            (theme/color [:steps-band :step-icon status :fg])})

(defn step-number
  []
  {:display   "block"
   :font-size (text-size :xxxsmall :size)})

(defn step-label
  [status]
  {:display     "block"
   :font-weight (when (= :active status)
                  (font-weight :bold))
   :font-size   (text-size :xsmall :size)})

(defn steps-band
  []
  ^{:media {{:screen :only :max-width (px 1200)}
            {:justify-content "start"}}}
  {:max-width       "100%"
   :display         "inline-flex"
   :justify-content "center"
   :margin-bottom   (edge-size :small)
   :border-radius   (border-radius :xxxsmall)
   :width           "100%"
   :overflow-x      "auto"
   :overflow-y      "hidden"})
